import type { User } from "../context/UserContext";

const TRIAL_MAX_MINUTES = 160;

const isTrialPlan = (user: User | null) => {
  const planTier = user?.subscription?.plan_tier ?? "";
  const planName = user?.subscription?.plan_name ?? "";
  const trial14 = /trial[\s_-]*14/i.test(planTier) || /trial[\s_-]*14/i.test(planName);
  const trial30 = /trial[\s_-]*30/i.test(planTier) || /trial[\s_-]*30/i.test(planName);
  return trial14 || trial30;
};

const getPlanMaxMinutes = (user: User | null) => {
  const maxMinutes = user?.subscription?.plan?.max_audio_minutes_per_session ?? null;
  if (typeof maxMinutes === "number" && maxMinutes > 0) return maxMinutes;
  return null;
};

export const getRecordingDurationLabel = (
  user: User | null,
  minMinutes: number,
  fallbackLabel: string
) => {
  if (isTrialPlan(user)) {
    return `Aufnahmedauer: ${minMinutes}–${TRIAL_MAX_MINUTES} min`;
  }

  const planMaxMinutes = getPlanMaxMinutes(user);
  if (planMaxMinutes) {
    return `Aufnahmedauer: ${minMinutes}–${planMaxMinutes} min`;
  }

  return fallbackLabel;
};

export const getRecordingMaxMinutes = (user: User | null, fallbackMax: number) => {
  if (isTrialPlan(user)) {
    return TRIAL_MAX_MINUTES;
  }
  const planMaxMinutes = getPlanMaxMinutes(user);
  if (planMaxMinutes) return planMaxMinutes;
  return fallbackMax;
};
